import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Custom spacing tokens from constants.css, so overrides like h-[62px] replace them
const twMerge = extendTailwindMerge({
  extend: { theme: { spacing: ['app-bar-mobile-height'] } },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
